import { ComponentProps, forwardRef, Ref } from 'react';
import CommentForm from './comment-form';

type CommentsFooterProps = Omit<
  ComponentProps<typeof CommentForm>,
  'disabled'
> & {
  isDisabled?: boolean;
};

const CommentsFooter = (
  {
    context,
    isDisabled,
    onSubmit,
    onReset,
    onError,
    onFormFocus,
    onFormBlur,
  }: CommentsFooterProps,
  ref: Ref<HTMLDivElement>
) => (
  <div ref={ref} className="comments__footer">
    <CommentForm
      onFormFocus={onFormFocus}
      onFormBlur={onFormBlur}
      context={context}
      disabled={isDisabled}
      onSubmit={onSubmit}
      onReset={onReset}
      onError={onError}
    />
  </div>
);

export default forwardRef(CommentsFooter);
